import {
  GET_STATISTICS,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_PREV_YEAR_SUCCESS,
} from '../constants/ActionsTypes'

export const getStatistics = (clientCode, dateFrom, dateTo, pageSize, page) => {
  return {
    type: GET_STATISTICS,
    payload: { clientCode, dateFrom, dateTo, pageSize, page },
  }
}

export const getStatisticsSuccess = (data) => {
  return {
    type: GET_STATISTICS_SUCCESS,
    data,
  }
}

export const getStatisticsPrevYearSuccess = (data) => {
  return {
    type: GET_STATISTICS_PREV_YEAR_SUCCESS,
    data,
  }
}
